<div class="pivot-dropdown">
  <div
    class="dropdown-header"
    [class.active]="headerActive()"
    (click)="onHeaderClick()"
  >
    <hyperkit-icon
      icon="circle-filled"
      size="small"
      [color]="status | queryStatusColor"
      class="code-icon"
    ></hyperkit-icon>
    <hyperkit-typography
      variant="emphasized"
      size="sm"
      class="header-label clickable"
      [wrap]="false"
      (click)="onHeaderClick(); $event.stopPropagation()"
    >
      {{ headerLabel }}
    </hyperkit-typography>
    <hyperkit-badge variant="neutral" [text]="headerCategory"></hyperkit-badge>
    <hyperkit-icon
      class="chevron"
      [icon]="isOpen('') ? 'chevron-down' : 'chevron-right'"
      size="small"
      (click)="toggle(''); $event.stopPropagation()"
    ></hyperkit-icon>
  </div>

  <ng-template #renderLevel let-items let-level="level" let-prefix="prefix">
    @if (isOpen(prefix)) {
      <div
        class="dropdown-list"
        [class.level-0]="level === 0"
        [class.nested]="level > 0"
        [attr.data-level]="level"
      >
        @for (opt of items; track opt) {
          <div
            class="dropdown-item pivot"
            [attr.data-level]="level"
            [style.padding-left.px]="12 + (level + 1) * 15"
            (click)="select(opt, level, prefix)"
            [class.active]="
              level === nav.pivotPath().length - 1 &&
              nav.pivotPath()[level] === opt.id
            "
          >
            <hyperkit-icon
              icon="circle-filled"
              size="small"
              [color]="opt.status | queryStatusColor"
              class="code-icon"
            ></hyperkit-icon>
            <hyperkit-typography
              variant="body"
              size="sm"
              [wrap]="false"
              class="endpoint-name"
            >
              {{ opt.title || opt.category }}
            </hyperkit-typography>
            <hyperkit-badge
              variant="neutral"
              [text]="opt.category"
            ></hyperkit-badge>
            @if (opt.pivots?.length) {
              <hyperkit-icon
                class="chevron"
                [icon]="
                  isOpen(pathKey(prefix, opt.id))
                    ? 'chevron-down'
                    : 'chevron-right'
                "
                size="small"
                (click)="
                  toggle(pathKey(prefix, opt.id)); $event.stopPropagation()
                "
              ></hyperkit-icon>
            }
          </div>
          @if (opt.pivots?.length && isOpen(pathKey(prefix, opt.id))) {
            <ng-container
              *ngTemplateOutlet="
                renderLevel;
                context: {
                  $implicit: opt.pivots,
                  level: level + 1,
                  prefix: pathKey(prefix, opt.id),
                }
              "
            ></ng-container>
          }
        }
      </div>
    }
  </ng-template>

  <ng-container
    *ngTemplateOutlet="
      renderLevel;
      context: { $implicit: items, level: 0, prefix: '' }
    "
  ></ng-container>
</div>
